
    import { mapActions } from 'vuex';
    import clampjs from 'clamp-js';

    import datalayer from '@/utils/datalayer';

    export default {
        name: 'EducationCard',

        inject: ['pageReferralElement'],

        props: {
            article: {
                type: Object,
                default: () => ({}),
            },
        },

        data() {
            return {
                eventData: {},
                cardTheme: {
                    'academy-xi': {
                        gradient: 'linear-gradient(180deg, rgba(0, 0, 0, 0.12) 0%, rgba(255, 255, 255, 0) 50%), #FFFFFF;',
                        color: '#000000',
                    },
                    uon: {
                        gradient: 'linear-gradient(180deg, rgba(0, 0, 0, 0.12) 0%, rgba(255, 255, 255, 0) 50%), #FFFFFF;',
                        color: '#000000',
                    },
                    tlp: {
                        gradient: 'linear-gradient(180deg, rgba(42, 45, 88, 0.12) 0%, rgba(255, 255, 255, 0) 50%), #FFFFFF;',
                        color: '#2A2D58',
                    },
                    candlefox: {
                        gradient: 'linear-gradient(180deg, rgba(220, 48, 39, 0.12) 0%, rgba(255, 255, 255, 0) 50%), #FFFFFF;',
                        color: '#DC2D27',
                    },
                    default: {
                        gradient: 'linear-gradient(180deg, rgba(74, 144, 226, 0.12) 0%, rgba(255, 255, 255, 0) 50%), #FFFFFF;',
                        color: '#4A90E2',
                    },
                    open_colleges: {
                        gradient: 'linear-gradient(180deg, rgba(0, 0, 0, 0.12) 0%, rgba(255, 255, 255, 0) 50%), #FFFFFF;',
                        color: '#A655E2',
                    },
                },
            };
        },

        computed: {
            getTheme() {
                return this.cardTheme[this.article.source] ? this.cardTheme[this.article.source] : this.cardTheme.default;
            },
        },

        mounted() {
            this.clampText();
        },

        methods: {
            ...mapActions('education', {
                $_postEducationArticleImpression: 'postEducationArticleImpression',
            }),

            ...mapActions('eventTracking', {
                $_pushEvent: 'pushEvent',
            }),

            clampText() {
                const titleEl = this.$refs.title;

                const clampTitle = {
                    clamp: this.$device.isMobileOrTablet ? 3 : 2,
                };

                clampjs(titleEl, clampTitle);

                if (['lg', 'xl', 'inf'].includes(this.$mq)) {
                    const descriptionEl = this.$refs.description;
                    const clampDescription = {
                        clamp: 4,
                    };
                    clampjs(descriptionEl, clampDescription);
                }
            },

            onSelect() {
                this.$emit('select', this.article);

                if (this.pageReferralElement) {
                    this.eventData.page_referral_element = this.pageReferralElement;
                }

                this.eventData.event = 'course_click';
                this.eventData.course_uuid = this.article.uuid;

                this.$_pushEvent(this.eventData);
                datalayer(this.eventData);
            },

            visibilityChanged(isVisible) {
                if (isVisible) {
                    this.$_postEducationArticleImpression(this.article.uuid);

                    if (this.pageReferralElement) {
                        this.eventData.page_referral_element = this.pageReferralElement;
                    }

                    this.eventData.event = 'course_impression';
                    this.eventData.course_uuid = this.article.uuid;

                    this.$_pushEvent(this.eventData);
                }
            },
        },
    };
